import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useRef } from "react";
import { useHotkeys } from "react-hotkeys-hook";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";
import { useConnectButtonCount } from "@/react/components/shared/Connect/useConnectButtonCount";

import { IconButton } from "../../IconButton";
import { BadgeIndicator } from "../BadgeIndicator";

export interface ConnectPopoverButtonProps {
  isOpen?: boolean;
}

export const ConnectPopoverButton = ({
  isOpen = false,
}: ConnectPopoverButtonProps) => {
  const connectButtonRef = useRef<HTMLButtonElement>(null);
  const { count } = useConnectButtonCount();

  useHotkeys(
    "alt+c",
    () => {
      connectButtonRef.current?.click();
    },
    [connectButtonRef],
  );

  return (
    <div className="relative">
      <TippyV2 interactive={false} content={t("header_v3.connect.title")}>
        <IconButton
          name="20-connections"
          buttonSize={36}
          iconSize={20}
          className={classNames(
            "hover:!bg-c-header-hover focus:!bg-c-header-hover !text-c-header hover:!text-c-header-active focus:!text-c-header-active !rounded-md p-1.5 duration-150",
            {
              "!bg-c-header-active !text-c-header-active": isOpen,
            },
          )}
          iconClassName={classNames("!text-inherit !transition-none")}
          ariaLabel={t("header_v3.connect.title")}
          ref={connectButtonRef}
          dataTestId="connect-panel-button"
        />
        {count > 0 && (
          <BadgeIndicator
            count={count}
            dataTestId="pending-connections-count"
          />
        )}
      </TippyV2>
    </div>
  );
};
